import { forwardRef, InputHTMLAttributes } from 'react';

export interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  className?: string;
  error?: boolean;
}

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className = '', error = false, type = 'text', ...props }, ref) => {
    const baseStyles =
      'w-full px-3 py-2 text-sm bg-white dark:bg-dark-card border rounded-md text-light-text dark:text-dark-text placeholder:text-light-muted dark:placeholder:text-dark-muted focus:outline-none focus:ring-2 focus:border-transparent transition-colors duration-150 disabled:opacity-50 disabled:cursor-not-allowed';

    const borderStyles = error
      ? 'border-error dark:border-error focus:ring-error'
      : 'border-light-border dark:border-dark-border focus:ring-accent-500';

    return (
      <input
        ref={ref}
        type={type}
        className={`${baseStyles} ${borderStyles} ${className}`}
        {...props}
      />
    );
  }
);

Input.displayName = 'Input';

export default Input;
